import styled from '@emotion/styled';
import Grid from '@react-css/grid';
import { Outlet, useLocation } from 'react-router-dom';
import { useAppSelector } from 'store';
import { selectIsSuperUser } from 'store/selectors/me/user';
import Card from 'storybookConfig/stories/cells/Card';
import Menu from 'storybookConfig/stories/cells/Menu';

const MenuWrapper = styled(Card)`
  padding: 24px;
  position: sticky;
  top: 24px;
`;

enum SectionSegments {
  Account = 'account',
  Security = 'security',
  Admin = 'admin',
}

const Preferences = () => {
  const isSuperUser = useAppSelector(selectIsSuperUser);
  const { pathname } = useLocation();
  const section = pathname.split('/')[3] as SectionSegments | undefined;

  const selectedSection =
    section && Object.values(SectionSegments).includes(section) ? section : SectionSegments.Account;

  return (
    <Grid columns="240px 1fr" gap="24px">
      <Grid.Item>
        <MenuWrapper>
          <Menu>
            <Menu.Link
              $iconName="account_circle"
              $isActive={selectedSection === SectionSegments.Account}
              to="/settings/preferences/account"
            >
              Account
            </Menu.Link>

            {isSuperUser && (
              <Menu.Link
                $iconName="admin_panel_settings"
                $isActive={selectedSection === SectionSegments.Admin}
                to="/settings/preferences/admin"
              >
                Admin
              </Menu.Link>
            )}
          </Menu>
        </MenuWrapper>
      </Grid.Item>

      <Card>
        <Outlet />
      </Card>
    </Grid>
  );
};

export default Preferences;
